import Config from "../_config/config";
import myAxios from "./axiositeachWrapper";

const BASE = `${Config.nodeSiteUrl}v1/tags/hierarchy`;

export interface TagTreeNode {
  key: number;
  type: "tagType" | "tag" | "school";
  title: string;
  name: string | null;
  children: TagTreeNode[];
  displayLabel?: string | null;
  code?: string | null;
  tagTypeId?: number;
  imageUrl?: string | null;
  additionalInfo?: string | null;
  description?: string | null;
}

export interface TagHierarchyResponse {
  success: boolean;
  data: { appliesTo: string; tree: TagTreeNode[] };
  message?: string;
}

/**
 * Node port of Java studentTags.do?reqCode=tagHierarchy&appliesTo=...
 * GET /api/v1/tags/hierarchy?appliesTo=question|school|topic|batch|...
 */
export interface TagCrudPayload {
  name: string;
  code?: string;
  description?: string;
  /** Set when adding a root tag directly under a tag type. */
  tagTypeId?: number;
  /** Set when adding a child tag under a parent tag. */
  parentTagId?: number;
}

const TAG_BASE = `${Config.nodeSiteUrl}v1/tags/tag`;

class TagHierarchyService {
  get = (appliesTo: string) =>
    myAxios.get<TagHierarchyResponse>(BASE, { params: { appliesTo } });

  // NOTE: myAxios is a raw axios instance whose post/put generic types the
  // REQUEST body, not the response — so we use <any> (codebase convention) and
  // read fields off res.data at the call site.
  create = (payload: TagCrudPayload) => myAxios.post<any>(TAG_BASE, payload);

  update = (id: number, payload: { name: string; code?: string; description?: string }) =>
    myAxios.put<any>(`${TAG_BASE}/${id}`, payload);

  remove = (id: number) => myAxios.delete<any>(`${TAG_BASE}/${id}`);
}

export default new TagHierarchyService();
